module.exports = __webpack_public_path__ + "models/robber_8de374fd4444bf997c54e6660a96eab6.glb";